import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { DeleteBinIcon, AddPlusIcon } from '../../../../assets/icons';
import { Form } from '../../../../shared/components';
import Text from '../../../../shared/components/Text';

import PRICES from '../../../../shared/prices';
import { styleUtils, formUtils } from '../../../../shared/utils';
import {updateAddOnsSummary, updateInstancesSummary as updateSummary} from '../OrderSummary/updateData'

import {
  formSchema,
  validationSchema,
  preSetupValidationSchema,
  preSetupFormSchema
} from './schemas';

import styles from './styles';
import {ROUTES} from "../../../../shared/constants/navigation";
import {DEFAULT_SERVICE_PERIOD, PURCHASE_DOMAIN} from "../../../../shared/constants/common";

const { style } = styleUtils;
const { getOptions } = formUtils;

const Container = style('div', styles.container);
const AddInstanceContainer = style('div', styles.addInstanceContainer);
const AddIcon = style(AddPlusIcon, styles.addPlusIcon);
const LabelContainer = style('div', styles.labelContainer);
const AddInstanceLabel = style(Text, styles.addInstanceLabel);

export const DEFAULT_VALUE_SUMMARY = '–';
const INSTANCES_SETUP = 'instancesSetup';

const OPTIONS = t => {
  const dhisVersion = getOptions(t, 'dhisVersion', [
    '242',
    '241',
    '240',
    '239',
    '238'
  ]);
  const instancePurpose = getOptions(t, 'instancePurpose', [
    'training',
    'development',
    'testing',
    'stating',
    'production',
    'other'
  ]);
  const urlType = getOptions(t, 'urlType', [
    'customerDomain',
    'baosystemsDomain',
    'purchaseDomain'
  ]);
  const hostingPlan = getOptions(t, 'hostingPlan', [
    't-2',
    't-3',
    't-4',
    't-5',
    't-6'
  ]);
  const servicePeriod = getOptions(t, 'servicePeriod', [
    '1',
    '3',
    '6',
    '12',
    '24'
  ]);
  return {
    dhisVersion,
    instancePurpose,
    urlType,
    hostingPlan,
    servicePeriod
  };
};

const defaultValues = {
  servicePeriod: DEFAULT_SERVICE_PERIOD
};

class InstancesConfiguration extends Component {
  constructor(props) {
    super(props);
    const { t, formData: { instances:data} } = props;

    this.state = {
      ...{
        instances: { [INSTANCES_SETUP]: {
          servicePeriod: '12'
          }, 1: {},
        },
        ...data
      },
      descriptions: {
        1: ''
      },
      options: OPTIONS(t)
    };
  }

  componentDidMount() {
    const { instances } = this.state;
    this.updateData(instances);
  }

  handleDeleteInstance = id => () => {
    this.setState(
      prevState => {
        const newInstances = { ...prevState.instances };
        delete newInstances[id];

        return { instances: newInstances };
      },
      () => {
        const { removeFromMultiForm } = this.props;
        const { instances } = this.state;
        this.updateData(instances);
        removeFromMultiForm(id);
      }
    );
  };

  handleOnAddInstanceClick = () => {
    const { instances } = this.state;
    const newInstances = { ...instances };
    const instancesIds = Object.keys(newInstances)
      .filter(id => id !== INSTANCES_SETUP)
      .sort();
    const lastInstanceId = instancesIds[instancesIds.length - 1];
    const newInstanceId = Number.parseInt(lastInstanceId) + 1;
    newInstances[newInstanceId] = {};
    this.setState({ instances: newInstances });
    this.updateData(newInstances);
  };

  handleOnChange = instanceId => (field, value) => {
    const { instances } = this.state;
    const newInstances = { ...instances };
    newInstances[instanceId][field] = value;
    this.updateData(newInstances);
  };

  getDomainPrice = () => {
    const { instances } = this.state;
    const totalDomain = Object.keys(instances).filter(item => instances[item].urlType === PURCHASE_DOMAIN);

    return PRICES.urlType.purchase * (totalDomain.length > 0 && 1);
  };

  updateData = newInstances => {
    const { changeData } = this.props;
    const { summary, descriptions } = updateSummary(newInstances, this.props, this.state);
    const domainTotal = this.getDomainPrice();
    const addOnsSummary = updateAddOnsSummary({name: 'domain', value: domainTotal}, this.props);

    changeData('instances')('instances', newInstances, summary);

    this.setState({descriptions}, ()=> {
      changeData('addOns')('domain', domainTotal, addOnsSummary);
    });
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { i18n, t } = this.props;
    if (i18n.language !== prevProps.i18n.language)
      this.setState({ options: OPTIONS(t) });
  }

  renderInstancesSetup = (id, t, options, values) => (
    <Form
      formId={id}
      key={id}
      isMultiForm
      onChange={this.handleOnChange(id)}
      validationSchema={preSetupValidationSchema(t, values)}
      formSchema={preSetupFormSchema(options, t, values)}
      title={t('instancesSetupTitle')}
      showFormButtons={false}
    />
  );

  render() {
    const { t, history } = this.props;
    const { instances, descriptions, options } = this.state;
    const instancesIds = Object.keys(instances);
    instancesIds.unshift(instancesIds.pop());
    const lastInstanceId = instancesIds[instancesIds.length - 1];

    return (
      <Container>
        {instancesIds.map(id => {
          const lastForm = id === lastInstanceId;
          const values = instances[id];
          const _values = { ...defaultValues, ...values };
          if (id === INSTANCES_SETUP)
            return this.renderInstancesSetup(id, t, options, _values);
          return (
            <Form
              formId={id}
              key={id}
              isMultiForm
              onChange={this.handleOnChange(id)}
              validationSchema={validationSchema(t, _values)}
              formSchema={formSchema(options, t, _values)}
              title={`${t('title')} #${id}`}
              previousButton={{
                label: t('previousButtonLabel'),
                action: () => history.push(ROUTES.SIGN_UP_CONTACT_INFORMATION)
              }}
              nextButton={{
                label: t('nextButtonLabel'),
                action: () => history.push(ROUTES.SIGN_UP_ADD_ONS)
              }}
              topButton={
                Number(id) !== 1
                  ? {
                      icon: <DeleteBinIcon />,
                      action: this.handleDeleteInstance(id)
                    }
                  : null
              }
              showFormButtons={lastForm}
              collapsable
              description={descriptions[id]}
              bottomComponent={
                lastForm ? (
                  <AddInstance t={t} onClick={this.handleOnAddInstanceClick} />
                ) : null
              }
            />
          );
        })}
      </Container>
    );
  }
}

const AddInstance = ({ t, onClick }) => (
  <AddInstanceContainer onClick={onClick}>
    <AddIcon />
    <LabelContainer>
      <AddInstanceLabel size="large">{t('addInstanceLabel')}</AddInstanceLabel>
    </LabelContainer>
  </AddInstanceContainer>
);

InstancesConfiguration.propTypes = {
  handleOnDataChange: PropTypes.func,
  handlePreviousStepClick: PropTypes.func,
  handleNextStepClick: PropTypes.func,
  data: PropTypes.object.isRequired
};

InstancesConfiguration.defaultProps = {
  data: {}
};

export default InstancesConfiguration;
